const updateItemsOrder = items => {
	return items.map((item, index) => ({
		...item,
		order: items.length - index
	}))
}

export default updateItemsOrder
